import { setSparxsEditorAuxiliaryReducer } from "@/store/app/sparxsEditorEditorReducer";

export const injectSparxsEditorAuxiliaryReducers = async (): Promise<void> => {
  const mod =
    await import("@/features/sparxsEditor/store/sparxsEditorAuxiliaryReducerBundle");
  setSparxsEditorAuxiliaryReducer(mod.createSparxsEditorAuxiliaryReducer());
};
